export const SENTRY_VERSION = 'cae8830c579aabb75e322dc0fdc43fe785930be9';



// WEBPACK FOOTER //
// ./src/sentry-version.ts